import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { MessagesService } from '../messages/messages.service';
import { Machine } from '../masterdata/models/machine';
import { ContainerStatus } from '../carrier-status/carrier-status';
import { SelectableLab } from '../carrier/selectable-lab';
import { ErrorHandler } from '../utils/error-handler';
import { CarrierState } from '../masterdata/models/carrierState';
import { CarrierSearchService } from '../carrier-search/carrier-search.service';
import { StepSequenceService } from './step-sequence.service';
import { saveAs as saveByFileSaver } from "file-saver";
import { ProcessState } from '../masterdata/models/processState-enum';
import { LabProcessingRequest } from '../carrier-status/processing-request';

@Component({
  selector: 'app-step-sequence',
  templateUrl: './step-sequence.component.html',
  styleUrls: ['./step-sequence.component.css']
})
export class StepSequenceComponent implements OnInit {

  createdBy: string;
  containerBarcode: string;
  selectedLab: SelectableLab;
  //selectedStatus: CarrierState;
  machineList: Machine[];
  stepSequenceForm: FormGroup;
  machineBarcode: string;
  isReadyForSubmit: boolean;
  carrierStatus: ContainerStatus[];
  errorHandler: ErrorHandler = new ErrorHandler;
  submitted: boolean;
  blocked: boolean

  @Input() carrierStateDetails: CarrierState;

  constructor(private formBuilder: FormBuilder, private carrierStatusService: CarrierStatusService,
    private _messagesService: MessagesService, private _carrierSearch: CarrierSearchService,
    private stepSequenceService: StepSequenceService) {
      this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }

  ngOnInit() {
    //Get the list machines on page loading
    this.carrierStatusService.getMachineList().subscribe(
      results => {
        this.machineList = results.data
      });

    this.stepSequenceForm = this.formBuilder.group({
      'createdBy': new FormControl('', Validators.required),
      'containerBarcode': new FormControl('', Validators.required),
      'machineBarcode': new FormControl('', Validators.required)
    });

    //this.selectedStatus = { _id: 'nonMdmId', name: ProcessStep.SEQUENCING, lab: this.selectedLab.lab, active: true , machineType:null, printer:null};
  }

  /**
   * @function
   * @param barcode
   * @description This method will download Sequencer Control file for given container barcode.
  */
  downloadControlFile() {
    this.blocked = true
    
    this.stepSequenceService.generateControlFile(this.containerBarcode.trim(), this.selectedLab.lab).subscribe(
      result => {
        if (!result) {
          return;
        }
        let controllerFileContent = result.sequencerControllerFileContent;
        let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
        let fileName: string = result.data.barcode + '.txt';
        saveByFileSaver(blob, fileName);
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded ABI Sequencer file' });
        this.blocked = false
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false
      }
    );
  }
  /**
   * @function
   * @description: This method is to add entry at start of the process of the Carrier State
   */
  start() {
    this.addCarrierStatus(ProcessState.STARTED)
  }
  /**
   * @function
   * @description: This method is to add entry at complete of the process of the Carrier State
   */
  cancel() {
    this.addCarrierStatus(ProcessState.CANCELED)
  }
  /**
   * @function
   * @description: This method is to add Carrier status Details
   */
  addCarrierStatus(processState: ProcessState) {

    this.blocked = true
    let status = new LabProcessingRequest;
    status.createdBy = this.createdBy
    status.containerBarcode = this.containerBarcode.trim();
    status.machineBarcode = this.machineBarcode.trim();
    status.processState = processState;
    status.lab = this.selectedLab.lab
    status.carrierState = this.carrierStateDetails
    status.machineType = this.carrierStateDetails.machineType;

    this.carrierStatusService.addCarrierStatus(status).subscribe(
      results => {
        if (processState == ProcessState.STARTED) {
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'process Started', detail: 'Sequencing step is started.. ' });
        }
        else if (processState == ProcessState.CANCELED) {
          this._messagesService.addSuccessMessage({ severity: 'warning', summary: 'process Cancelled', detail: 'Sequencing step is cancelled.. ' });
        }
        this.blocked = false
      },
      error => {
        if (error != null && error.error != null && error.error.bbApiError != null && error.error.bbApiError.errors != null) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: error.error.bbApiError.title, detail:this.getSubErrors(error.error.bbApiError.errors) });
        }else{
          this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
        }
        this.blocked = false
      }
    );
    this.isReadyForSubmit = true;
  }

  // used to get all the sub errors in the single string
  getSubErrors(errors:any[]){
    var errorText : string =''
    for(var e = 0; e < errors.length; e++){
      errorText += errors[e].message;
      if(e != errors.length - 1){
        errorText += (",");
      }
    }
    return errorText;
  }

  /**
   * @function
   * @description: This method is to get the focus to Carrier Barcode Field
   */
  focusContainerbarcode() {
    document.getElementById('containerfield').focus();
  }
  /**
   * @function
   * @description: This method is to get the focus to Machine Barcode Field
   */
  focusMachinebarcode() {
    document.getElementById('machinefield').focus();
  }

  /**
  * @function
  * @description: This method to avoid default submit
  */
  disableDefaultSubmit(event) {
    event.preventDefault();
    event.target.blur();
  }

  /**
   * @function
   * @description: This method is to TBD
   */
  onSubmit(value: string) {
    if (this.isReadyForSubmit) {
      this.submitted = true;
      this.stepSequenceForm.reset();
      document.getElementById('createdby').focus();
      this.isReadyForSubmit = false;
    }
  }
}
